import { render } from "./IconAngleDown.vue?vue&type=template&id=22fa00e9&ts=true"
import script from "./IconAngleDown.vue?vue&type=script&lang=ts"
export * from "./IconAngleDown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__